export default "__VITE_ASSET__e52e5f41__$_?component__"